// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2o-1";
export var movingGradient = "_2o-4";
export var movingGradientBlock = "_2o-2";
export var skeleton = "_2o-0";
export var skeletonText = "_2o-3";